import { ca } from '@cian/analytics';

import { EMessageFileTypes } from '../../types/messageFiles';

const TRACK_FILE_LABEL = {
  [EMessageFileTypes.Image]: 'Photo',
  [EMessageFileTypes.ImageAsDocument]: 'Document',
  [EMessageFileTypes.Document]: 'Document',
};

interface IProps {
  action: 'Reload_sopr' | 'Delete_sopr';
  fileType: EMessageFileTypes;
  chatId: string;
  label?: string;
  opponentId?: number;
}

export function trackFileErrorMenuClick({ action, fileType, chatId, label, opponentId }: IProps) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action,
    label: label || TRACK_FILE_LABEL[fileType],
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
      },
    },
  });
}
